<template>
    <svg :height="height" viewBox="0 0 1080 1080" :width="width" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
        <g id="24dff842-632f-457a-a23b-c3325b8ee738" transform="matrix(1 0 0 1 540 540)">
            <rect
                height="1080"
                rx="0"
                ry="0"
                style="
                    stroke: none;
                    stroke-width: 1;
                    stroke-dasharray: none;
                    stroke-linecap: butt;
                    stroke-dashoffset: 0;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 4;
                    fill: rgb(255, 255, 255);
                    fill-rule: nonzero;
                    opacity: 1;
                    visibility: hidden;
                "
                vector-effect="non-scaling-stroke"
                width="1080"
                x="-540"
                y="-540"
            />
        </g>
        <g id="64281acb-55e7-40a8-8b2c-cc437e05412e" transform="matrix(1 0 0 1 540 540)"></g>
        <g transform="matrix(1 0 0 1 540 540)">
            <g style="" vector-effect="non-scaling-stroke">
                <g transform="matrix(1.68 0 0 1.68 0 0)">
                    <path
                        :style="'fill:' + color"
                        d="M 370.605 149.413 L 391.47700000000003 119.94200000000001 C 395.259 114.59800000000001 393.999 107.19800000000001 388.64500000000004 103.403 L 357.18500000000006 81.12200000000001 C 351.83900000000006 77.34300000000002 344.4320000000001 78.60600000000001 340.6480000000001 83.95000000000002 L 319.2650000000001 114.13800000000002 C 303.4860000000001 106.75500000000002 286.5400000000001 101.45500000000001 268.7810000000001 98.64300000000001 L 268.7810000000001 86.358 C 268.7810000000001 78.5 275.21300000000014 72.065 283.0740000000001 72.065 L 290.9570000000001 72.065 C 298.8270000000001 72.065 305.2610000000001 65.628 305.2610000000001 57.772999999999996 L 305.2610000000001 14.301 C 305.261 6.435 298.827 0 290.957 0 L 186.455 0 C 178.598 0 172.167 6.435 172.167 14.301 L 172.167 57.773 C 172.167 65.628 178.598 72.065 186.455 72.065 L 194.351 72.065 C 202.214 72.065 208.647 78.5 208.647 86.358 L 208.647 98.643 C 189.60999999999999 101.67 171.505 107.518 154.78 115.762 L 133.598 85.857 C 129.81 80.512 122.40400000000001 79.248 117.05900000000001 83.036 L 85.598 105.31 C 80.247 109.09700000000001 78.986 116.505 82.771 121.848 L 104.13 152.024 C 69.54599999999999 186.535 48.126999999999995 234.235 48.126999999999995 286.845 C 48.126999999999995 391.93500000000006 133.62599999999998 477.42400000000004 238.71300000000002 477.42400000000004 C 343.79900000000004 477.42400000000004 429.297 391.93500000000006 429.297 286.845 C 429.297 232.894 406.758 184.112 370.605 149.413 z M 238.713 431.688 C 158.843 431.688 93.868 366.709 93.868 286.844 C 93.868 206.97699999999998 158.843 141.998 238.713 141.998 C 318.578 141.998 383.56100000000004 206.97699999999998 383.56100000000004 286.844 C 383.561 366.708 318.578 431.688 238.713 431.688 z"
                        stroke-linecap="round"
                        style="
                            stroke: none;
                            stroke-width: 1;
                            stroke-dasharray: none;
                            stroke-linecap: butt;
                            stroke-dashoffset: 0;
                            stroke-linejoin: miter;
                            stroke-miterlimit: 4;
                            fill-rule: nonzero;
                            opacity: 1;
                        "
                        transform=" translate(-238.71, -238.71)"
                        vector-effect="non-scaling-stroke"
                    />
                </g>
                <g transform="matrix(1.68 0 0 1.68 0 80.65)">
                    <path
                        :style="'fill:' + color"
                        d="M 358.124 285.889 C 357.607 220.478 304.24600000000004 167.41000000000003 238.71300000000002 167.41000000000003 C 238.39100000000002 167.41000000000003 238.074 167.43900000000002 237.76200000000003 167.43900000000002 L 237.76200000000003 285.889 L 119.3 285.889 C 119.29299999999999 286.201 119.27499999999999 286.517 119.27499999999999 286.845 C 119.27499999999999 352.384 172.343 405.737 237.762 406.25600000000003 C 238.075 406.25600000000003 238.391 406.273 238.713 406.273 C 304.566 406.273 358.147 352.706 358.147 286.845 C 358.146 286.517 358.124 286.201 358.124 285.889 z"
                        stroke-linecap="round"
                        style="
                            stroke: none;
                            stroke-width: 1;
                            stroke-dasharray: none;
                            stroke-linecap: butt;
                            stroke-dashoffset: 0;
                            stroke-linejoin: miter;
                            stroke-miterlimit: 4;
                            fill-rule: nonzero;
                            opacity: 1;
                        "
                        transform=" translate(-238.71, -286.84)"
                        vector-effect="non-scaling-stroke"
                    />
                </g>
            </g>
        </g>
        <g id="189ad95c-2f2e-4c47-845b-f9e031a7bd04" transform="matrix(5.83 0 0 5.56 543.82 615.12)">
            <circle
                :style="'fill:' + color"
                cx="0"
                cy="0"
                r="35"
                style="
                    stroke: #6aa84f;
                    stroke-width: 0;
                    stroke-dasharray: none;
                    stroke-linecap: butt;
                    stroke-dashoffset: 0;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 4;
                    fill-rule: nonzero;
                    opacity: 1;
                "
                vector-effect="non-scaling-stroke"
            />
        </g>
    </svg>
</template>
<style scoped></style>
<script setup lang="ts">
    import { computed, onMounted } from 'vue';

    const props = defineProps({
        color: {
            type: String,
            default: 'black',
        },
        size: {
            type: Number,
            default: 24,
        },
    });

    const width = computed(() => props.size + 'px');
    const height = computed(() => props.size + 'px');

    onMounted(() => {
        console.log('Component %s mounted.', 'app-full-time');
    });
</script>
